import Web3 from "web3";
import { getWeb3Provider } from "../../utils/rpcProvider";
export const getminMLD = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.minMLD());
};

export const getBaseAPY = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.baseAPY());
};

export const getTotalMLDLocked = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.totalMLDLocked());
};

export const getUnstakeLordFeesPercentage = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.unstakeLordFeesPercentage());
};

export const getLordRatio = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.lordRatio());
};

export const getPreMatureMLDPenalty = async (mldStakingContract) => {
  return parseInt(await mldStakingContract.preMatureMLDPenalty());
};

// export const getStakeDurationInSec = async (duration) => {
//   return parseInt(await mldStakingContract.stakeDurationInSec(duration));
// }

export const getDurationwiseStake = async (
  mldStakingContract,
  durationStake
) => {
  return await mldStakingContract.durationwiseStake(durationStake);
};

export const getUserDeposits = async (
  mldStakingContract,
  defaultAccount,
  index
) => {
  return await mldStakingContract.userDeposits(defaultAccount, index);
};

export const maticSendToken = async (signer, data) => {
  try {
    const tx = await signer.sendTransaction(data);
    const rec = await tx.wait();
    return rec;
  } catch (err) {
    console.log(err);
  }
};
export const gasEstimateMatic = async (allContractDetails, data) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const data1 = allContractDetails?.signer.sendTransaction(data).encodeABI();
    const gasPrice = await web3.eth.getGasPrice();
    const transactionObject = {
      from: allContractDetails?.address,
      to: data?.receiveAddress,
      data: data1,
    };
    const gasEstimate = await web3.eth.estimateGas(transactionObject);
    // console.log(gasPrice, gasEstimate, "---------------------matic gas");
  } catch (err) {
    console.log(err);
  }
};
export const mldStakingDeposit = async (mldStakingContract, mldAmount, sec) => {
  const tx = await mldStakingContract.stake(mldAmount, sec);
  const rec = await tx.wait();
  return rec;
};

export const getUserTotalDeposits = async (mldStakingContract, userAddress) => {
  return await mldStakingContract.userTotalDeposits(userAddress);
};

export const getCalculateReward = async (
  mldStakingContract,
  mldAmount,
  sec
) => {
  return await mldStakingContract.calculateMaturityAmount(mldAmount, sec);
};

// export const getUserNextUnlock = async (userAddress) => {
//   return await mldStakingContract.userNextUnlock(userAddress);
// }

export const getUserLatestId = async (mldStakingContract, userAddress) => {
  return await mldStakingContract.userLatestId(userAddress);
};

export const mldWithdraw = async (mldStakingContract, index) => {
  const tx = await mldStakingContract.withdraw(index.toString());
  const rec = await tx.wait();
  return rec;
};
